var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg34Circle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4375 4.68751C19.1349 3.3786 17.5863 2.34028 15.8808 1.63234C14.1753 0.924391 12.3466 0.560803 10.5 0.562506V14.625L0.5625 24.5625C6.04688 30.0469 14.9531 30.0469 20.4609 24.5625C21.7662 23.2569 22.8011 21.7068 23.5064 20.0007C24.2118 18.2947 24.5737 16.4663 24.5716 14.6201C24.5694 12.774 24.2031 10.9465 23.4937 9.24211C22.7844 7.53773 21.7458 5.98999 20.4375 4.68751Z",
    fill: "#eb2426"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg34Circle);
export default __webpack_public_path__ + "static/media/3-4-circle.58de2f72cb1725e0a6974fdfb2ce44b9.svg";
export { ForwardRef as ReactComponent };